import { Popup } from "@/components/dialog/Popup";
import OrderPaymentReceiptPopover from "@/components/payment/OrderPaymentReceiptPopover.vue";

import { TastierClient } from "@/app/TastierClient";
import { trans } from "@/app/localization/Trans";
import { VueContentPopover } from "@/app/popover/VueContentPopover";

export class SendOrderPrintReceiptPopover extends VueContentPopover {
    constructor(orderId: string) {
        super({ popoverClass: "sendreceipt", title: trans.receipt.receipt, fullscreen: false });

        const props = {
            orderId: orderId,
            locationId: TastierClient.context.currentAllocation!.locationId,
            userIsWaiter: TastierClient.identityContext?.isWaiterInCurrentLocation(),
            onSendReceiptSuccess: () => this.hide(),
            onPrintSuccess: () => {
                Popup.show({
                    message: trans.receipt.receiptPrinted,
                    confirmHandler: () => this.hide(),
                });
            },
        };
        this.initComponent(OrderPaymentReceiptPopover, props);
    }
}
